export { default } from './get-image'
export type { GetImageArgs } from './get-image'
